import { api } from "@/lib/api/client";
import { partnerEndpoints } from "@/lib/api/endpoints";
import type {
  ApplicationDetail,
  ApplicationListParams,
  ApplicationListResponse,
  CreateApplicationPayload,
  FinancingDetailsPayload,
  UpdateApplicationPayload,
} from "@/types/application";

export async function listApplications(
  params: ApplicationListParams = {},
): Promise<ApplicationListResponse> {
  const query: Record<string, string | number> = {};
  if (params.q?.trim()) query.q = params.q.trim();
  if (params.status && params.status !== "all") query.status = params.status;
  if (params.page) query.page = params.page;

  return api.get<ApplicationListResponse>(partnerEndpoints.applications, { params: query });
}

export async function getApplication(uuid: string): Promise<ApplicationDetail> {
  return api.get<ApplicationDetail>(partnerEndpoints.application(uuid));
}

export async function createApplication(
  payload: CreateApplicationPayload,
): Promise<ApplicationDetail> {
  return api.post<ApplicationDetail>(partnerEndpoints.applications, {
    ...payload,
    company_type: payload.company_type ? Number(payload.company_type) : null,
  });
}

export async function updateApplication(
  uuid: string,
  payload: UpdateApplicationPayload,
): Promise<ApplicationDetail> {
  return api.patch<ApplicationDetail>(partnerEndpoints.application(uuid), payload);
}

export async function updateFinancingDetails(
  uuid: string,
  payload: FinancingDetailsPayload,
): Promise<ApplicationDetail> {
  return api.patch<ApplicationDetail>(partnerEndpoints.application(uuid), payload);
}
